module.exports = __webpack_public_path__ + "img/top-5-4.01de9302.jpg";